import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X, MessageCircle } from "lucide-react";
import { WA_GENERAL } from "@/data/products";

const LINKS = [
  { label: "Materiales", hash: "#materiales", id: "nav-link-materiales" },
  { label: "Nosotros", hash: "#nosotros", id: "nav-link-nosotros" },
  { label: "Servicios", hash: "#servicios", id: "nav-link-servicios" },
  { label: "Contacto", hash: "#contacto", id: "nav-link-contacto" },
];

export const scrollToHash = (hash) => {
  const el = document.querySelector(hash);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -72, duration: 1.4 });
  else el.scrollIntoView({ behavior: "smooth" });
};

export default function Navbar() {
  const [open, setOpen] = useState(false);

  const go = (hash) => (e) => {
    e.preventDefault();
    setOpen(false);
    scrollToHash(hash);
  };

  return (
    <header className="fixed top-0 inset-x-0 z-50 bg-[#04070D]/70 backdrop-blur-xl border-b border-[#1A2235]">
      <div className="max-w-[1440px] mx-auto px-5 md:px-10 h-[72px] flex items-center justify-between">
        <a href="#" onClick={(e) => { e.preventDefault(); window.__lenis?.scrollTo(0); }} data-testid="nav-logo" className="flex items-center gap-3">
          <img src="/assets/logo.jpg" alt="ANGORA MATERIALES" className="logo-invert h-10 w-auto rounded-sm" />
          <span className="font-display font-800 tracking-tight text-lg hidden sm:block" style={{ fontWeight: 800 }}>
            ANGORA<span className="text-[#FF7A00]">.</span>
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-8">
          {LINKS.map((l) => (
            <a key={l.hash} href={l.hash} onClick={go(l.hash)} data-testid={l.id}
              className="text-sm text-[#8B95A5] hover:text-white transition-colors duration-200 font-medium tracking-wide">
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a href={WA_GENERAL} target="_blank" rel="noopener noreferrer" data-testid="nav-quote-button"
            className="hidden md:inline-flex items-center gap-2 bg-[#FF7A00] hover:bg-[#E06A00] text-white text-sm font-semibold px-5 py-2.5 rounded-sm transition-colors duration-200">
            <MessageCircle size={16} /> Cotizar
          </a>
          <button onClick={() => setOpen(!open)} data-testid="nav-mobile-toggle" aria-label="Menú"
            className="md:hidden text-white p-2 border border-[#1A2235] rounded-sm">
            {open ? <X size={20} /> : <Menu size={20} />}
          </button>
        </div>
      </div>

      <AnimatePresence>
        {open && (
          <motion.nav
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.3, ease: [0.16, 1, 0.3, 1] }}
            className="md:hidden overflow-hidden border-t border-[#1A2235] bg-[#04070D]"
            data-testid="nav-mobile-menu"
          >
            <div className="px-5 py-6 flex flex-col gap-5">
              {LINKS.map((l) => (
                <a key={l.hash} href={l.hash} onClick={go(l.hash)} data-testid={`${l.id}-mobile`}
                  className="font-display text-2xl font-bold tracking-tight text-white">
                  {l.label}
                </a>
              ))}
              <a href={WA_GENERAL} target="_blank" rel="noopener noreferrer" data-testid="nav-quote-button-mobile"
                className="inline-flex items-center justify-center gap-2 bg-[#FF7A00] text-white font-semibold px-5 py-3 rounded-sm mt-2">
                <MessageCircle size={18} /> Cotizar por WhatsApp
              </a>
            </div>
          </motion.nav>
        )}
      </AnimatePresence>
    </header>
  );
}
